export enum MemoTabChoices {
  CONTENT_EDITOR = "content_editor",
  SAVED_PDFS = "saved_pdfs",
}

export enum MemoSnapshotCreationMethod {
  DEFAULT = "default",
  E_SIGN_PROCESS = "e_sign_process",
}

export const TABS: Array<{
  label: string;
  value: MemoTabChoices;
}> = [
  { label: "Content editor", value: MemoTabChoices.CONTENT_EDITOR },
  { label: "Saved PDFs", value: MemoTabChoices.SAVED_PDFS },
];
